/** Strip a single trailing slash from an origin or base URL. */
export function stripTrailingSlash(url: string): string {
  return url.replace(/\/$/, '');
}

/**
 * Join an origin with a path, normalizing slashes.
 * Does not encode query params or handle Capacitor native origins.
 */
export function joinOriginPath(origin: string, path: string): string {
  const normalizedOrigin = stripTrailingSlash(origin);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedOrigin}${normalizedPath}`;
}

/**
 * Build a browser magic-link redirect template from the current origin.
 * Placeholders like `{{email}}` / `{{magicCode}}` are left untouched for the backend.
 */
export function buildBrowserMagicLinkRedirectUrl(
  origin: string,
  pathWithPlaceholders: string,
): string {
  return joinOriginPath(origin, pathWithPlaceholders);
}
